import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

// Logged-out hub homepage = product launcher only. Imported eagerly
// so anonymous visitors never see an intermediate fallback hero —
// HubLauncher is the single homepage and this file resolves to it
// synchronously on first paint.
import HubLauncher from "@/pages/HubLauncher";

// Authed dashboard is the only lazy boundary — its hooks and grids
// add ~120 KB that anonymous visitors do not need.
const IndexAuthedDashboard = lazy(() => import("@/pages/IndexAuthedDashboard"));

const AuthGate = () => (
  <div
    className="min-h-screen flex items-center justify-center bg-background"
    role="status"
    aria-label="Loading your dashboard"
    aria-busy="true"
  >
    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
  </div>
);

const Index = () => {
  const { user, isLoading } = useAuth();
  // While the auth session is restoring, show a neutral spinner instead
  // of flashing the anonymous launcher at a returning signed-in user.
  if (isLoading) return <AuthGate />;
  if (!user) return <HubLauncher />;
  // Authed: spinner fallback while the dashboard chunk streams — never the
  // anonymous launcher (would briefly show the wrong homepage).
  return (
    <Suspense fallback={<AuthGate />}>
      <IndexAuthedDashboard />
    </Suspense>
  );
};

export default Index;
